import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { UserPlanProvider } from './context/UserPlanContext';
import { ProfileProvider } from './context/ProfileContext';
import { PrivacyProvider } from './context/PrivacyContext';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import KeyboardCap from './components/KeyboardCap';
import { initNative } from './native/capacitorBootstrap';
import reportWebVitals from './reportWebVitals';

// Debug-Konsole auf native iOS — zeigt console.log/Fehler/Network direkt auf dem Handy.
// Wird nur geladen wenn Capacitor native platform erkannt wird.
if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) {
  import('eruda').then(m => m.default.init());
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Ionic-Kompatibilitäts-Spike: ?ionicspike=1 → isolierte Ionic-Test-App. LAZY
// geladen, damit Ionics globale CSS NICHT in die echte App bündelt. Kein
// StrictMode (react-router v5 + Ionic zickt darunter).
const isIonicSpike = new URLSearchParams(window.location.search).has('ionicspike');
const IonicSpike = React.lazy(() => import('./IonicSpike'));

root.render(
  isIonicSpike ? (
    <React.Suspense fallback={null}>
      <IonicSpike />
    </React.Suspense>
  ) : (
    <React.StrictMode>
      <ErrorBoundary>
        <AuthProvider>
          <ThemeProvider>
            <CurrencyProvider>
              <UserPlanProvider>
                <ProfileProvider>
                  <PrivacyProvider>
                    <App />
                    <KeyboardCap />
                  </PrivacyProvider>
                </ProfileProvider>
              </UserPlanProvider>
            </CurrencyProvider>
          </ThemeProvider>
        </AuthProvider>
      </ErrorBoundary>
    </React.StrictMode>
  )
);

// Native-Bootstrap (OTA-Ready, StatusBar, Splash) — No-op im Web.
initNative();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
